import { Directive, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RouteActionEvent, RouteDetailKind, RouteReportModalState } from '../../route-analysis-report.models';
import { DETAIL_DEFINITIONS, ROUTE_MODAL_IDS, emptyRouteModalState } from '../../route-analysis-report.utils';
import { RouteReportModalComponent } from './route-report-modal.component';

@Directive()
export abstract class RouteDetailModalPresenter {
  abstract readonly kind: RouteDetailKind;
  @Input() state: RouteReportModalState = emptyRouteModalState();
  @Output() closing = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
  @Output() rowAction = new EventEmitter<RouteActionEvent>();
  @ViewChild(RouteReportModalComponent) modal?: RouteReportModalComponent;
  get modalId(): string { return ROUTE_MODAL_IDS[this.kind]; }
  get title(): string { return DETAIL_DEFINITIONS[this.kind].title; }
  get table() { return this.modal?.table; }
  hide(): void { this.modal?.hide(); }
}
